import HotelBadges from './HotelBadges';
export default HotelBadges;